import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ResetMultipleSaleQuantityState from "@MasterBluePrint/Store/Components/ProductDetails/ResetMultipleSaleQuantityState";
import { Draft } from "immer";

const initialState: ResetMultipleSaleQuantityState = {
    resetMultipleSaleQuantity: false
};

const reducer = {
    "Components/ProductDetails/ResetMultipleSaleQuantity": (
        draft: Draft<ResetMultipleSaleQuantityState>,
        action: {
            reset: boolean;
        },
    ) => {
        draft.resetMultipleSaleQuantity = action.reset;
    },
};


export default createTypedReducerWithImmer(initialState, reducer);